<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/mago-university/mago-university']">
    <span translate>MENU.UNIVERSITY</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span *ngIf="!trainingPlans" translate>COMMONS.COURSES</span>
  <span *ngIf="trainingPlans" translate>COMMONS.COURSESPLANS</span>
</div>

<tb-header specificTitle="MENU.UNIVERSITY" parentPage="productsdownload"></tb-header>

<div class="contentGlobal text-left">
  <ms-courses-viewer [trainingPlans]="trainingPlans"></ms-courses-viewer>
</div>
